const firebaseConfig = {
    apiKey: "AIzaSyCOeMYYbcxiRiERLbdfKm_xxzGIDTDq210",
    authDomain: "scenezenfilms.firebaseapp.com",
    projectId: "scenezenfilms",
    storageBucket: "scenezenfilms.appspot.com",
    messagingSenderId: "99185143225",
    appId: "1:99185143225:web:ade90e03f1047f0d9eda68"
  };

  export default firebaseConfig;